import { useTranslation } from 'react-i18next'

/** translation.json 이 있는 앱 언어 코드. 중국어는 표준 BCP47 이 아니라 'cn' 이다. */
export type AppLanguage = 'ko' | 'en' | 'ja' | 'cn'

const INTL_LOCALES: Record<AppLanguage, string> = {
    ko: 'ko-KR',
    en: 'en-US',
    ja: 'ja-JP',
    cn: 'zh-CN'
}

const MAPS_REGIONS: Record<AppLanguage, string> = {
    ko: 'KR',
    en: 'US',
    ja: 'JP',
    cn: 'CN'
}

/** 'ko-KR'·'zh-CN'·'cn' 처럼 들어와도 앱 언어 코드 하나로 맞춘다. 알 수 없으면 fallbackLng 인 en. */
export const normalizeLanguage = (language?: string | null): AppLanguage => {
    const lower = language?.toLowerCase() ?? ''
    if (lower.startsWith('ko')) return 'ko'
    if (lower.startsWith('ja')) return 'ja'
    if (lower.startsWith('cn') || lower.startsWith('zh')) return 'cn'
    return 'en'
}

/** toLocaleString·Intl·date-fns 등에 넘길 BCP47 로케일. */
export const toIntlLocale = (language?: string | null): string => INTL_LOCALES[normalizeLanguage(language)]

/** Google Maps 로더에 넘길 region·language. */
export const toMapsConfig = (language?: string | null) => {
    const lang = normalizeLanguage(language)
    return { region: MAPS_REGIONS[lang], language: lang === 'cn' ? 'zh-CN' : lang }
}

/**
 * 현재 선택된 언어와 그 로케일. 언어를 바꾸면 이 훅을 쓰는 컴포넌트가 다시 그려진다.
 * `i18n.language === 'ja'` 처럼 직접 비교하면 'ja-JP' 같은 브라우저 감지값이나 'cn' 에서 한국어로 새므로 쓰지 않는다.
 */
export const useAppLocale = () => {
    const { i18n } = useTranslation()
    const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language)
    return { language, intlLocale: INTL_LOCALES[language] }
}
